import React from 'react';
import { OmniIconComponent } from '../../../../../shared';
import '../../../../../styles/SyncWithPrismaConfirmation.scss';

/**
 * SyncWithPrismaConfirmation Component
 * 
 * A reusable confirmation dialog that allows users to choose whether to sync 
 * a new media order with Prisma or create it without syncing.
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Controls visibility of the confirmation dialog
 * @param {Function} props.onCancel - Callback when user clicks Cancel
 * @param {Function} props.onDontSync - Callback when user clicks "Don't Sync with Prisma"
 * @param {Function} props.onSync - Callback when user clicks "Sync with Prisma"
 * 
 * @example
 * <SyncWithPrismaConfirmation
 *   isOpen={showConfirmation}
 *   onCancel={() => setShowConfirmation(false)}
 *   onDontSync={handleCreateOrderWithoutSync}
 *   onSync={handleCreateOrderWithSync}
 * />
 */
const SyncWithPrismaConfirmation = ({ isOpen, onCancel, onDontSync, onSync }) => {
    if (!isOpen) return null;

    return (
        <div className="sync-prisma-confirmation-overlay">
            <div className="sync-prisma-confirmation-modal">
                <div className="sync-prisma-header">
                    <h2>Sync with Prisma?</h2>
                    <button className="close-button" onClick={onCancel} aria-label="Close">
                        <OmniIconComponent icon-id="omni:interactive:close" />
                    </button>
                </div>

                <div className="sync-prisma-content">
                    <p>
                        "Sync with Prisma" will create a new campaign in Prisma, where placements can 
                        be synced directly from Media Ops Hub.
                    </p>
                </div>

                <div className="sync-prisma-actions">
                    <button className="tertiary" onClick={onCancel}>
                        Cancel
                    </button>
                    <button className="secondary" onClick={onDontSync}>
                        Don't Sync with Prisma
                    </button>
                    <button className="primary" onClick={onSync}>
                        Sync with Prisma
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SyncWithPrismaConfirmation;